export default {
  PENDING: "ORIG",
  TRANSIT: "CERR",
  ARRIVED: "PEND",
  DELIVERY: "REPA",
  DELIVERED: "EFEC",
  UNDELIVERED: "NOEF",
  CANCELL: "CANC"
};
